import CheckoutPage from './Checkout';
import Cart from './Checkout/pages/Cart';
import Order from './Checkout/pages/Order';
import { Summary, } from './Checkout/pages/Summary';
import { Confirm, } from './Checkout/pages/Confirm';

export { default as Home } from './Home';
export { default as Product } from './Product';
export { default as Login } from './Login';
export { default as Products } from './Products';
export { default as AccessInformation } from './AccessInformation';

export const Checkout = {
    Main: CheckoutPage,
    Cart,
    Order,
    Summary,
    Confirm,
};
